var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiamondIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#7BB8FD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.9999,
    cy: 13,
    r: 9.1,
    fill: "#3D7EF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0156 12.6836H15.0068C14.346 14.7933 13.6872 16.8957 13.0287 18.9985L12.9937 18.9977C12.3352 16.8965 11.6772 14.7952 11.0156 12.6836Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4111 12.6793C17.4408 14.7917 15.4978 16.8744 13.5552 18.9575L13.5332 18.9445C13.6225 18.6569 13.7111 18.369 13.8008 18.0819C14.348 16.3332 14.8967 14.585 15.44 12.8351C15.4774 12.7147 15.5286 12.675 15.6587 12.6758C16.8478 12.682 18.0369 12.6793 19.2259 12.6793H19.4111Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4232 18.8167C10.4952 16.7801 8.56683 14.7435 6.62305 12.6904C6.67888 12.6846 6.71392 12.6777 6.74896 12.6777C7.96614 12.6773 9.18331 12.6777 10.4009 12.6758C10.486 12.6758 10.5376 12.6858 10.568 12.7836C11.1868 14.7693 11.8098 16.7539 12.4317 18.7389C12.4386 18.7608 12.4421 18.7839 12.4475 18.8063L12.4236 18.8167H12.4232Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38872 9.19531C9.02522 10.2103 9.64632 11.2007 10.2782 12.2084H6.5C7.12765 11.2072 7.74952 10.2149 8.38872 9.19531Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.81055 9H12.5864C11.9553 10.0065 11.335 10.9962 10.6989 12.0104C10.0662 11.0015 9.4459 10.0123 8.81055 9Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8974 12.2116H11.125C11.755 11.2062 12.3749 10.2174 13.0106 9.20312C13.6425 10.2104 14.2629 11.1993 14.8974 12.2116Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3229 11.9997C14.691 10.9916 14.0745 10.0086 13.4473 9.00781H17.1981C16.5743 10.0028 15.9571 10.9882 15.3229 11.9997Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6336 9.21875C18.2624 10.2214 18.8758 11.1995 19.5003 12.196H15.7676C16.3875 11.2064 17.0017 10.2264 17.6332 9.21875H17.6336Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondIcon);
export default __webpack_public_path__ + "static/media/diamondIcon.a9c333424ee08765767d21deb5e5a358.svg";
export { ForwardRef as ReactComponent };